"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeLinkIndex = serializeLinkIndex;
exports.handleLinkIndexResource = handleLinkIndexResource;
const dist_1 = require("../../../fs/dist");
/**
 * Converts a Map to a plain id-keyed object. `JSON.stringify` of a Map yields `{}`
 * (Maps have no enumerable own properties), which is why the raw LinkIndex used to
 * serialize as all-empty objects over the wire — this is the fix.
 */
function mapToObject(map, transform) {
    const out = {};
    for (const [key, value] of map) {
        out[key] = transform ? transform(value) : value;
    }
    return out;
}
/**
 * Serializes a LinkIndex into a JSON-safe, id-keyed shape. Maps become plain objects
 * and Sets become arrays, so `byId` / `documents` (the id→path data) actually reach
 * the client instead of being dropped as `{}`.
 */
function serializeLinkIndex(index) {
    return {
        documents: mapToObject(index.documents),
        byId: mapToObject(index.byId),
        bySlug: mapToObject(index.bySlug),
        backlinks: mapToObject(index.backlinks),
        children: mapToObject(index.children, (set) => [...set]),
        parent: mapToObject(index.parent),
        stepBlockers: mapToObject(index.stepBlockers),
    };
}
async function handleLinkIndexResource(root) {
    const index = await (0, dist_1.buildLinkIndex)(root);
    return {
        contents: [{
                uri: 'loom://link-index',
                mimeType: 'application/json',
                text: JSON.stringify(serializeLinkIndex(index), null, 2),
            }],
    };
}
